import resourcesStore from '@/store/modules/resources.js'
import { map, pipe } from 'ramda'

const resources = () => resourcesStore.state.resources
const formatScore = data =>
  data.score !== null
    ? data
    : { ...data, score: resources().page.home.comparation.notApply }

const filterMetricById = availableMetric => ({ metric_id: metricId }) =>
  metricId === availableMetric.metricId

const getGroupMetric = availableMetric => ({
  metrics,
  group_id: groupId,
  visible,
}) => {
  let metric = metrics.find(filterMetricById(availableMetric))
  if (metric) {
    const m = { ...metrics.find(filterMetricById(availableMetric)) }
    if (m.submetrics) {
      delete m.submetrics
    }
    return {
      ...m,
      groupId,
      visible,
    }
  }

  const [metricId, submetricId] = availableMetric.metricId.split(':')

  metric = metrics.find(filterMetricById({ metricId }))

  const submetric = metric.submetrics.find(
    ({ submetric_id }) => submetric_id === submetricId
  )

  if (submetric) {
    return {
      metric_id: `${metricId}:${submetricId}`,
      ...submetric,
      groupId,
      visible,
    }
  }

  return {
    metric_id: `${metricId}:${submetricId}`,
    score: null,
    groupId,
    visible,
  }
}

export default (availableMetrics, groupsData) =>
  map(availableMetric =>
    pipe(
      map(getGroupMetric(availableMetric)),
      map(formatScore)
    )(groupsData)
  )(availableMetrics)
